export const environment = {
  production: false,
  apiUrl: 'https://api.transformer.platform.dev.transflo.com/api/v1',
  portalSiteUrl: 'https://portal.dev.transflo.com/',
  portalApiUrl: 'https://gateway.dev.transflo.com/portal/graphql',
};
